import React from "react";
import { Routes, Route } from "react-router-dom";
import CompanyList from "./components/CompanyList"; // Main company list page
import CompanyPage from "./components/CompanyPage"; // Company detail page
import SignUp from "./components/Signup"; // Sign-up page
import CompanyDetails from "./components/CompanyDetails"; // Additional company details page

const App: React.FC = () => {
  return (
    <Routes>
      {/* Route to the main company list page */}
      <Route path="/" element={<CompanyList />} />

      {/* Route to the company detail page */}
      <Route path="/company/:id" element={<CompanyPage />} />

      {/* Route to the sign-up page */}
      <Route path="/signup" element={<SignUp />} />

      {/* Route to the company details page */}
      <Route path="/companydetails" element={<CompanyDetails />} />
    </Routes>
  );
};

export default App;
